<template>
  <div class="container"></div>
</template>

<script>
import { lsModalService } from 'ls-vue-common';
import { ReturnRequestModal } from '@/modals';
import { mapMutations } from 'vuex';
import { DISPUTE__RESET } from '@/store/types';

export default {
  name: 'ReturnRequestView',
  created() {
    lsModalService.open({
      parent: this,
      component: ReturnRequestModal,
      canCancel: [],
    });
  },
  destroyed() {
    this[DISPUTE__RESET]();
  },
  methods: {
    ...mapMutations([DISPUTE__RESET]),
  },
};
</script>

<style lang="scss" scoped></style>
